const BACKEND_URL = API_URL;
import { API_URL } from './apiConfig';

export const sendAIMessage = async (
  message: string,
  systemPrompt: string,
  sessionId?: string,
  imageBase64?: string,
  imageType?: string
): Promise<string> => {
  const body: any = {
    message,
    system_prompt: systemPrompt,
    session_id: sessionId || `session_${Date.now()}`
  };

  if (imageBase64) {
    // Strip data URL prefix if present
    const base64Data = imageBase64.includes(',') ? imageBase64.split(',')[1] : imageBase64;
    body.image_base64 = base64Data;
    body.image_type = imageType || 'image/jpeg';
  }

  const response = await fetch(`${BACKEND_URL}/api/chat`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  });

  if (!response.ok) {
    const error = await response.text();
    throw new Error(`AI request failed: ${error}`);
  }

  const data = await response.json();
  return data.response;
};
